export default __webpack_public_path__ + "static/media/MACS-FO.2323a023.svg";